<template>
  <div class="project-page">
    <ProjectHero :project="project" />
    <FeatureGrid :features="project.features" :color="project.color" subtitle="30+ 类工具一站搞定，从基类、蓝牙、总线到相机、Shell，持续完善" />

    <!-- 工具分类导航 -->
    <section class="section nav-section">
      <div class="container">
        <div data-aos="fade-up">
          <span class="section-eyebrow">CATEGORIES</span>
          <h2 class="section-title">工具分类速览</h2>
          <p class="section-subtitle">覆盖 Android 开发各领域的工具集合，每个类上方注释都有用法</p>
        </div>
        <div class="cat-cloud" data-aos="fade-up" data-aos-delay="80">
          <span v-for="c in categories" :key="c" class="cat-chip">
            <i class="fa-solid fa-check"></i> {{ c }}
          </span>
        </div>
      </div>
    </section>

    <CodeSection
      :code-blocks="project.codeBlocks"
      :gradle-block="project.gradleBlock"
      :maven-block="project.mavenBlock"
      subtitle="Toast、Log、Bus、权限、弹窗、拍照、转换、校验、线程、TTS 等分类代码"
    />

    <section class="section" style="padding-top:0">
      <div class="container">
        <div class="proj-cta-box" data-aos="fade-up">
          <div>
            <h3 class="proj-cta-title">具体每个类方法和使用</h3>
            <p class="proj-cta-desc">请查看文档或源码，每个类上面注释都有用法，欢迎提出修改意见。</p>
          </div>
          <a :href="project.repo" target="_blank" rel="noopener" class="btn btn-primary">
            <i class="fa-brands fa-github"></i> 查看源码
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { projects } from '@/data/projects.js'
import ProjectHero from '@/components/ProjectHero.vue'
import FeatureGrid from '@/components/FeatureGrid.vue'
import CodeSection from '@/components/CodeSection.vue'

const project = projects.yutils

const categories = [
  '各种基类', '蓝牙控制', '自定义总线', '加密解密', 'SQLite 数据库',
  'Socket 长连接', 'UDP 通信', '图片处理', '日期处理', '自定义对话框',
  'GPS 获取', '计时器', '通知栏下载', '处理队列', '延迟操作',
  '防粘连操作', '文件处理', '对象保存', '线程池', '单例 Toast',
  'APP 版本更新', '快速拍照', '选择相册', '截图', 'WebView 封装',
  '相机封装', '多媒体播放', 'PopupWindow', '类型转换', 'Shell 执行'
]
</script>

<style scoped>
.nav-section { border-top: 1px solid var(--border-soft); }
.cat-cloud {
  margin-top: 48px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.cat-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  background: var(--bg-surface);
  border: 1px solid var(--border-soft);
  border-radius: 100px;
  font-size: 0.86rem;
  color: var(--text-muted);
  transition: all 0.2s ease;
}
.cat-chip:hover {
  color: var(--accent);
  border-color: var(--accent);
  background: var(--accent-soft);
  transform: translateY(-2px);
}
.cat-chip i { font-size: 0.7rem; color: var(--android); }

.proj-cta-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  background: var(--bg-surface);
  border: 1px solid var(--border-soft);
  border-radius: 16px;
  padding: 36px 40px;
}
.proj-cta-title { font-family: var(--font-display); font-weight: 600; font-size: 1.5rem; margin-bottom: 6px; }
.proj-cta-desc { color: var(--text-muted); }
</style>
